import { ApiErrorDTO, CurrentUserDTO, getCurrentUserResponse } from "@bvhi/backend-api";
import { QueryObserverResult, RefetchOptions } from "@tanstack/react-query";
import { createContext } from "react";

export interface IAuthContext {
  currentUser: CurrentUserDTO | undefined;
  refetch: (options?: RefetchOptions) => Promise<QueryObserverResult<getCurrentUserResponse, ApiErrorDTO>>;
}

const defaultState: IAuthContext = {
  currentUser: undefined,
  refetch: () =>
    new Promise<QueryObserverResult<getCurrentUserResponse, ApiErrorDTO>>(() => {
      console.warn("AuthContext: Not in scope");
    }),
};

export const AuthContext = createContext<IAuthContext>(defaultState);
